import React, { useState } from 'react';
import ProductsV2 from '../ProductsV2';
import './styles.css';

const Products = () => {
  return <ProductsV2 />
};

export default Products;
